import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import { StyledImg } from '../../../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';

export function Intro(props: IQuestionnaireFormProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        HSDQ vragenlijst
                    </Heading>
                </Stack>

                <Stack>
                    <StyledImg
                        alt="HSDQ questionnaire intro"
                        src="/assets/images/somnology/questionnaires/slapend-meisje.png"
                    />
                </Stack>

                <Stack>
                    <Text>
                        Beantwoord 32 vragen van de Holland Sleep Disorder Questionnaire (HSDQ) om de slaaparts een
                        aanwijzing te geven over de oorzaak van je slaapklachten. Het gaat over de klachten die je had{' '}
                        <b>in de afgelopen drie maanden.</b>
                    </Text>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Start vragenlijst
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
